<template>
    <modal-centered-generic
    titleIcon="card-add"
    rightButtonIcon="arrow-right-full"
    :text="modalText"
    :title="t('cards.consult.addNewCardModal.title')"
    :rightButtonText="t('cards.consult.addNewCardModal.continueBtn')"
    @hideMe="emit('hideMe')"
    @rightButtonClicked="redirectToFeatureHandler">
        <selector-radio-group
        :radioParams="radioParams"
        @clicked="radioSelectedClicked"/>
    </modal-centered-generic>
</template>

<script setup>
import ModalCenteredGeneric from '@/components/generic/modals/centered/Generic'
import SelectorRadioGroup from '@/components/generic/selectors/radio/RadioGroup'

/* Vue & Assets */
import { ref, onMounted } from 'vue'
import { getCurrentRouteMenuItemInfo } from '@/assets/scripts/parsers/menu'
import { navigateByPath } from '@/router/helpers/navigation'
import { routeList } from '@/router/helpers/routes'

/* i18n */
import { useI18n } from 'vue-i18n'
const { t } = useI18n()

/* Emmitters */
const emit = defineEmits(['hideMe'])

/* Props
@dashboardWidget {Boolean} - prop to apply logics for this to be used on dashboardWidget
*/
const props = defineProps({
	dashboardWidget: Boolean
})

const radioParams = ref([])
const modalText = ref('')

/* ***********************************************
*             Parser Logic for Options           *
*********************************************** */
const createRadioOptions = () => {
	const routeToGetInfo = props.dashboardWidget ? routeList.CARDS_BASE_PATH : null
    radioParams.value = []

    if (!getCurrentRouteMenuItemInfo(routeToGetInfo) || !getCurrentRouteMenuItemInfo(routeToGetInfo).children.length) return

    const menuEntriesForAccelarator = getCurrentRouteMenuItemInfo(routeToGetInfo).children

    if (menuEntriesForAccelarator.find(obj => obj.label === 'cards_request')) {
        modalText.value = t('cards.consult.addNewCardModal.textOnlyNewCard')
        radioParams.value.push({
            id: 'request-new',
            text: t('cards.consult.addNewCardModal.newCardRadio'),
            value: 'request-new',
            selected: true
        })
    }
    if (menuEntriesForAccelarator.find(obj => obj.label === 'cards_consult_activate')) {
        modalText.value = t('cards.consult.addNewCardModal.textOnlyActivate')
        radioParams.value.push({
            id: 'activate',
            text: t('cards.consult.addNewCardModal.activateRadio'),
            value: 'activate',
            selected: false
        })
    }
    if (radioParams.value.length === 2) modalText.value = t('cards.consult.addNewCardModal.text')
}

const radioSelectedClicked = id => {
    radioParams.value.forEach(obj => {
        obj.selected = obj.id === id
    })
}

const redirectToFeatureHandler = () => {
    const selectedOption = radioParams.value.find(obj => obj.selected).id

    navigateByPath(selectedOption === 'request-new' ? routeList.CARDS_REQUEST_PATH : routeList.CARDS_ACTIVATE_PATH)

    emit('hideMe')
}

onMounted(() => {
    createRadioOptions()
})
</script>

<style lang="scss" scoped>
.radio-group-wrapper {
    margin-top: 16px;
}
</style>
